import { ReactNode } from "react";

interface ContainerProps {
  children: ReactNode;
  className?: string;
}

const Container = ({ children, className }: ContainerProps) => {
  return (
    <div className={`${className ?? ""} pb-24 mx-auto max-w-container mt-36 `}>{children}</div>
  );
};

export default Container;
